import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClinichedatabaseService } from '../../services/clinichedatabase.service';
import { LoaderService } from '../../loader/loader.service';
import { AlertDialogService } from '../../services/alert-dialog.service';
import { Confirm } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';
import { ExcelService } from '../../services/excel.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

import "moment-timezone";

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

import { ClinicheDatabase } from '../../entities/datibase/clinichedatabase-model';
import { windowWhen } from 'rxjs/operators';

const tz = "Europe/Rome";
const dateFormat = "YYYY-MM-DDTHH:mm:ss";

const dateFormatDate = "YYYY-MM-DD";
const dateFormatHour = "HH:mm";

@Component({
  selector: 'target2-import',
  templateUrl: './target2-import.component.html',
  styleUrls: ['./target2-import.component.css']
})
export class Target2ImportComponent implements OnInit {
  role: string;
  isAdmin: boolean = false;
  isCA: boolean = false;
  isDC: boolean = false;
  usr: any;
  willDownload = false;

  constructor(public dialogRef: MatDialogRef<Target2ImportComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private dbService: ClinichedatabaseService, private loaderService: LoaderService, private alertDialog: AlertDialogService,
    private fb: FormBuilder, private _sanitizer: DomSanitizer, private http: HttpClient) {
    console.log('DATA INJECTED %o', moment(data.fromDate).endOf('month').format('YYYY-MM-DD') + 'T00:00:00');

    this.role = data.role;
    this.usr = data.usr;

    if (this.role != null && (this.role.toLowerCase() == 'amministratore' || this.role.toLowerCase() == 'amministratore dp' || this.role.toLowerCase() == 'hr medici')) {
      this.isDC = false;
      this.isAdmin = true;
      this.isCA = false;
    }
    if (this.role != null && (this.role.toLowerCase() == 'direzione commerciale')) {
      this.isDC = true;
      this.isAdmin = false;
      this.isCA = false;
    }
    if (this.role != null && (this.role.toLowerCase() == 'ciclo_attivo' || this.role.toLowerCase() == 'ciclo attivo')) {
      this.isDC = false;
      this.isAdmin = false;
      this.isCA = true;
    }

  }

  parseDateExcel(excelTimestamp) {
    const secondsInDay = 24 * 60 * 60;
    const excelEpoch = new Date(1899, 11, 31);
    const excelEpochAsUnixTimestamp = excelEpoch.getTime();
    const missingLeapYearDay = secondsInDay * 1000;
    const delta = excelEpochAsUnixTimestamp - missingLeapYearDay;
    const excelTimestampAsUnixTimestamp = excelTimestamp * secondsInDay * 1000;
    const parsed = excelTimestampAsUnixTimestamp + delta;
    return isNaN(parsed) ? null : parsed;
  }

  setDownload(data) {
    this.willDownload = true;
    setTimeout(() => {
      const el = document.querySelector("#download");
      el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
    }, 1000)
  }

  onFileChange(ev) {
    console.log('start import');
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    if (this.isAdmin == true || this.isDC == true) {
      if (window.confirm('Vuoi sovrascrivere i dati presenti nel file Excel con quelli nel DB?')) {
        this.loaderService.show();
        reader.onload = (event) => {
          const data = reader.result;
          workBook = XLSX.read(data, { type: 'binary' });
          console.log('workbook A %o', workBook);
          jsonData = workBook.SheetNames.reduce((initial, name) => {
            const sheet = workBook.Sheets[name];
            initial[name] = XLSX.utils.sheet_to_json(sheet);
            return initial;
          }, {});
          console.log('jsonData A %o', jsonData);

          const dataString = JSON.stringify(jsonData);
          console.log('dataString A %o', dataString);
          document.getElementById('output').innerHTML = dataString.slice(0, 1000).concat("...");

          //this.setDownload(dataString);

          //var obj = JSON.parse(jsonData);
          let arrayCall = [];
          let jsonDataC = jsonData['target'];

          for (var it in jsonDataC) {
            console.log('jsonDataC[it] %o', jsonDataC[it]);
            if (jsonDataC[it]['__EMPTY_1'] != null && jsonDataC[it]['__EMPTY_1'].length > 0) {
              let codC = jsonDataC[it]['__EMPTY_1'].substr(0, 3);

              let clinica = {};

              clinica['CodClinica'] = codC;
              clinica['TgCheckUp'] = jsonDataC[it]['__EMPTY_4'] || 0;
              clinica['Mese'] = moment(this.data.fromDate).endOf('month').format('YYYY-MM-DD') + 'T00:00:00';
              clinica['TgFatturato'] = jsonDataC[it]['__EMPTY_2'] || 0;
              clinica['TgProduzione'] = jsonDataC[it]['__EMPTY_3'] || 0;

              //  let ret1 = this.http.post(`${environment.gceAPI}/update_target_f_p`, clinicagennaio, { responseType: 'json' });
              let ret2 = this.http.post(`${environment.gceAPI}/update_target_f_p`, clinica, { responseType: 'json' });
              // let ret3 = this.http.post(`${environment.gceAPI}/update_target_f_p`, clinicamarzo, { responseType: 'json' });
              // let ret1 = this.http.post(`http://localhost:57526/api/update_target_f_p`, clinicagennaio, { responseType: 'json' });

              //  arrayCall.push(ret1);
              arrayCall.push(ret2);
              // arrayCall.push(ret3);
              console.log('CALL RET %o', ret2);
              // console.log('CALL RET %o',ret2);
            }
          }

          Observable.forkJoin(arrayCall).subscribe(results => {
            window.alert('Import terminato');
            this.loaderService.hide();
          }, err => {
            this.loaderService.hide();
            window.alert('Errore nella procedura di importazione.');
            this.dialogRef.close();
          });

        }
        reader.readAsBinaryString(file);
      }
    }
    else {
      window.alert('Att.ne: il tuo profilo non è abilitato per importare dati da file Excel')
    }
  }

  cancel() {
    this.loaderService.hide();
    this.dialogRef.close();
  }

  ngOnInit() {

  }


}
